/*
 * $Id:: ApplicationFilters.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { t } from '../../providers';
import SearchFilter from '../SearchFilter';
import DropdownFilters from './DropdownFilters';
import FilterActionButtons from './FilterActionButtons';
import FilterChips from './FilterChips';

const useStyles = makeStyles(() => ({
    actionsContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        width: '100%',
        marginBottom: '40px',
    },
    searchRow: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        margin: '10px 0px',
    },
    filtersRow: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        margin: '10px 0px',
    },
    filterTextRow: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
    },
    toggleFilters: {
        margin: '20px 0 0',
        color: '#1976D2',
        fontSize: '16px',
        '&:hover': {
            cursor: 'pointer',
        },
    },
}));

const ApplicationFilters = ({
    applicationType,
    filtersValues,
    setFiltersValues,
    clearFilters,
    exportApplications,
    filterItems,
    datesOptions = 'dates',
    initiateServices,
    initiateServicesOptions,
    selectedApplications = [],
    authorities,
    filterType,
    searchEnabled = true,
    myApplicationsFilters = null,
    page = '',
}) => {
    const classes = useStyles();
    const isTablet = useMediaQuery('(max-width:960px)');

    const [searchQuery, setSearchQuery] = useState('');
    const [filters, setFilters] = useState({});
    const [filtersChips, setFiltersChips] = useState({});
    const [hideFilters, setHideFilters] = useState(false);

    useEffect(() => {
        setSearchQuery(filtersValues.searchQuery || '');
        setFilters(filtersValues.filters || {});
        setFiltersChips(filtersValues.filtersChips || {});
    }, [filtersValues]);

    const toggleFilters = () => {
        setHideFilters(!hideFilters);
    };

    const handleUpdateFilters = (filtersObject, optionSelected) => {
        for (let key in filtersObject) {
            // eServices filters: clean formTypes filter if ipRightType is changed
            if (key === 'ipRightType' && filtersValues.filters[key] !== filtersObject[key] && filtersObject['formTypes']) {
                delete filtersObject['formTypes'];
                delete optionSelected['formTypes'];
            }
            //remove filters with no options selected from active filters
            if (filtersObject[key].length <= 0 && key !== 'dates') {
                delete filtersObject[key];
                delete optionSelected[key];
            }
        }
        setFiltersValues({ ...filtersValues, filters: filtersObject, filtersChips: optionSelected });
    };

    const search = (query) => {
        const trimmedQuery = query.trim();

        if (trimmedQuery.length > 2) {
            setFiltersValues({ ...filtersValues, searchQuery: query });
        }
    };

    const clearSearch = () => {
        setFiltersValues({ ...filtersValues, searchQuery: '' });
    };

    const exportTypes = exportApplications
        ? [
              { label: 'PDF', action: () => exportApplications('pdf') },
              { label: 'EXCEL', action: () => exportApplications('excel') },
          ]
        : null;

    const filtersChipsView = !!Object.keys(filters || {}).length && (
        <div className={classes.filterTextRow}>
            <FilterChips filteredBy={filtersChips} onClearFilters={clearFilters} />
        </div>
    );

    const filtersSection = (
        <div className={classes.filtersRow}>
            <DropdownFilters
                filterItems={filterItems}
                onUpdateFilters={handleUpdateFilters}
                filters={filters}
                applicationType={applicationType}
                datesOptions={datesOptions}
                filtersChips={filtersChips}
                isTablet={isTablet}
                authorities={authorities}
                filterType={filterType}
                myApplicationsFilters={myApplicationsFilters}
                page={page}
            />
        </div>
    );

    const toggleFiltersLabel = hideFilters ? t('show.filter.options') : t('hide.filter.options');

    return (
        <div className={classes.actionsContainer}>
            {(searchEnabled || exportTypes || !!initiateServicesOptions?.length) && (
                <div className={classes.searchRow}>
                    {searchEnabled && <SearchFilter onSearch={search} searchQuery={searchQuery} onClear={clearSearch} />}
                    <FilterActionButtons
                        exportTypes={exportTypes}
                        onInitiateServices={initiateServices}
                        initiateServicesOptions={initiateServicesOptions}
                        disableInitiateServices={!selectedApplications.length}
                    />
                </div>
            )}
            {!!isTablet ? (
                <React.Fragment>
                    {filtersChipsView}
                    {!hideFilters && filtersSection}
                    <div className={classes.toggleFilters} onClick={toggleFilters}>
                        {toggleFiltersLabel}
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    {filtersSection}
                    {filtersChipsView}
                </React.Fragment>
            )}
        </div>
    );
};

export default ApplicationFilters;
